import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from 'react';
import { PaginationHandle } from '../misc/Pagination/Pagination';
export function useArrayPagination(items, pageSize) {
  const $ = _c(10);
  const [page, setPage] = useState(1);
  const zeroIndexedPage = page - 1;
  let t0;
  if ($[0] !== items || $[1] !== pageSize || $[2] !== zeroIndexedPage) {
    t0 = items.slice(zeroIndexedPage * pageSize, (zeroIndexedPage + 1) * pageSize);
    $[0] = items;
    $[1] = pageSize;
    $[2] = zeroIndexedPage;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const currentPageItems = t0;
  const maxPage = Math.max(Math.ceil(items.length / pageSize), 1);
  let t1;
  if ($[4] !== maxPage || $[5] !== page) {
    t1 = {
      minPage: 1,
      maxPage,
      page,
      setPage
    };
    $[4] = maxPage;
    $[5] = page;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== currentPageItems || $[8] !== t1) {
    t2 = {
      paginationHandle: t1,
      currentPageItems
    };
    $[7] = currentPageItems;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}